import React, { useState, useEffect } from 'react'
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import { Button, Badge, Modal, Form } from 'react-bootstrap'


import Dialog from '../../services/Dialogs'


const Departamentos = () => { 

	const dialog = new Dialog()

	const [ lista_deptos, setDeptos ] = useState<any>([])

  const [show, setShow] = useState(false);

  const [ requisitos_disponibles, setRequisitosDisponibles ] = useState<any>([])

  const [ departamento_seleccionado, setDeptoSelect ] = useState<any>({})

  const handleClose = () =>{
  	cargarMiReporte()
  	setShow(false);
  }
  const handleShow = async (depto:any) =>{
  	setDeptoSelect(depto)
  	let req = await RequestService.getEndPoint('departamento/requisitos_disponibles/'+depto.uuid)
  	setRequisitosDisponibles(req.data)
  	setShow(true);
  }


  const cargarMiReporte = async()=>{
    try{
      let response = await RequestService.getEndPoint('lista_deptos')
      setDeptos(response.data)
    }
    catch(e){
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }

  React.useEffect(() => {
    cargarMiReporte()
  }, []);

  const actualizarRequisitos = (i:number, tipo:string, value: boolean) =>{

  		if(tipo=='check'){
	      var arreglo = [...requisitos_disponibles]
	      arreglo[i].check = value
	      setRequisitosDisponibles(arreglo)
	  }
  		if(tipo=='obligatorio'){
	      var arreglo = [...requisitos_disponibles]
	      arreglo[i].obligatorio = value
	      setRequisitosDisponibles(arreglo)
	  }
  }


  const agregarRequisitosDepartamento = async () => {
        try{
          if(await dialog.confirm('¿Deseas agregar estos requisitos para el alta de un trámite?', {})){
            let req = await RequestService.create('departamento/agregar_requisitos_tramite/'+ departamento_seleccionado.uuid , { requisitos : requisitos_disponibles} )
            toast('Los cambios se hicieron')
          }
          else{
            toast.warning('UPS')
          }

        }
        catch(e){
          toast.error('tramites/actualizar_datos_ciudadano/:uuid')
        }
  }


  const eliminarRequisitoDepto = async (uuid_requisito:string) => {
        try{
          if(await dialog.confirm('¿Deseas eliminar este requisito del trámite?', {})){
            await RequestService.delete('departamento/eliminar_requisito/'+ uuid_requisito )
            toast.warning('Los cambios se hicieron')
            cargarMiReporte()
          }
          else{
            toast.warning('UPS')
          }

        }
        catch(e){
          toast.error('tramites/actualizar_datos_ciudadano/:uuid')
        }
  }





  const [showNuevoRequisito, setShowNuevoRequisito ] = useState(false);

  const [ nuevo_requisito, setNuevoRequisito ] = useState("")

  const handleCloseNuevoRequisito = () => setShowNuevoRequisito(false);
  const handleShowNuevoRequisito = () =>{
  	setShowNuevoRequisito(true);
  	setNuevoRequisito("")
  }


  const crearRequisito = async () => {
        try{
          if(await dialog.confirm('¿Estás seguro?', {})){
			  	let req = await RequestService.create('departamento/crear_requisito', { requisito : nuevo_requisito })
			  	// console.log(req)
			  	setShowNuevoRequisito(false);
			  	setNuevoRequisito('')
          }
          else{
            toast.warning('UPS')
          }

        }
        catch(e){
          toast.error('tramites/actualizar_datos_ciudadano/:uuid')
        }

  }

	return (

			<React.Fragment>

				<div className="container">
					

				{
					// JSON.stringify(lista_deptos)
				}

				<h4>Configuración y Consulta en Departamentos</h4>
<div className="text-secondary">
  <hr/>
</div>


<ul className="list-inline">
  <li className="list-inline-item">
  	<Button onClick={handleShowNuevoRequisito} variant="primary">Crear Requisito</Button>
  </li>
</ul>


<table className="table">
<thead>
  <tr>
    <th>UUID</th>
    <th>Departamento</th>
    <th>Requisitos</th>
    <th></th>
  </tr>
  </thead>
  <tbody>
  	{
  		lista_deptos.map( depto =>

			  <tr key={ Math.random().toString(36).substr(2, 9) }>
			    <td width="300px" className="v">
				    <small>{ depto.uuid }</small>
			    </td>
			    <td className="v" width="300px">
			    	<h6 className="nm">{ depto.departamento }</h6>
			    </td>
			    <td className="v">

					{
						depto.requisitos.map( requisito =>

							<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
								<Badge className="nm" bg={ requisito.obligatorio ? 'primary' : 'light' }>
                  {requisito.idrequisito.requisito} <i onClick={()=>{eliminarRequisitoDepto(requisito.uuid)}} className="fa cursor fa-trash" />
                 </Badge>{' '}
							</React.Fragment>

						)
					}


			    	{
			    		// JSON.stringify(depto.requisitos)
			    	}
			    </td>
			    <td className="v text-center" width="50px">
			    	<Button variant="secondary" className="cursor" size="sm" onClick={()=>{handleShow(depto)}}>
			    		<i className="fa fa-plus" /> 
			    	</Button>
			    </td>
			  </tr>


  		)
  	}

  </tbody>
</table>



				</div>


      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Requisitos</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        	<p><b>Requisitos Disponibles</b></p>

        	<h4>{departamento_seleccionado.departamento}</h4>
        	{
        		// JSON.stringify(requisitos_disponibles)
        	}

<table className="table">
	<tbody>
		{
			requisitos_disponibles.map( (requisito : any, i : number) =>

				  <tr key={ Math.random().toString(36).substr(2, 9) }>
				    <th>

				      <Form.Group >
				        <Form.Check type="checkbox" className="nm" 
					        onChange={(e)=>{ actualizarRequisitos(i,'check',!requisitos_disponibles[i].check ) }} checked={requisitos_disponibles[i].check}
					        id={'req_'+i} label={requisito.requisito}  />
				      </Form.Group>
              
				    </th>
				    <th>

				      <Form.Group >
				        <Form.Check type="checkbox" className="nm" style={{ fontWeight : 'normal', fontSize: '12px' }} 
				        	disabled={!requisitos_disponibles[i].check} onChange={(e)=>{ actualizarRequisitos(i,'obligatorio',!requisitos_disponibles[i].obligatorio ) }} checked={requisitos_disponibles[i].obligatorio}
				        	id={'requi_'+i} label="Obligatorio"  />
				      </Form.Group>


				    </th>
				  </tr>

			)
		}
	</tbody>
</table>
        	
        	{
        		requisitos_disponibles.length == 0 && (

					    <p><i className="fa fa-warning"/> No puedes agregar más requisitos al trámite de este departamento.</p>

        			)
        	}




        </Modal.Body>
        	{
        		requisitos_disponibles.length > 0 && (

				        <Modal.Footer>
				          <Button variant="danger" onClick={handleClose}>
				            Cerrar
				          </Button>
				          <Button variant="primary" onClick={()=>{agregarRequisitosDepartamento()}}>
				            Agregar
				          </Button>
				        </Modal.Footer>


        			)
        	}

      </Modal>





      <Modal show={showNuevoRequisito} onHide={handleCloseNuevoRequisito}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        	<h6>Nuevo Requisito</h6>
        	<p>Al crear un nuevo requisito podrás usarle en cualquier trámite de cualquier departamento</p>
        	
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>Nombre del Requisito</Form.Label>
        <Form.Control type="text" value={nuevo_requisito} onChange={(event)=>{setNuevoRequisito(event.target.value.toUpperCase())}} placeholder="" />
      </Form.Group>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseNuevoRequisito}>
            Cancelar
          </Button>
          <Button variant="primary" disabled={nuevo_requisito.length==0?true:false} onClick={crearRequisito}>
            Crear Requisito
          </Button>
        </Modal.Footer>
      </Modal>


			</React.Fragment>

		)

}



export default Departamentos